import { ClampLines as _ClampLines, ClampLinesProps } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation';

export const ClampLines = (props: Omit<ClampLinesProps, 'seeMoreText' | 'seeLessText'>) => {
  const { t } = useTranslation();
  return (
    <_ClampLines {...props} seeMoreText={t('common:clampLines.seeMore')} seeLessText={t('common:clampLines.seeLess')} />
  );
};
